<!-- zhangziao -->
<template>
    <div class="w100">
        <article class="wContent center" style="padding: 10px 0 20px 0">

            <el-row :gutter="20" class="base-part-1">
                <el-col :span="16">
                    <div class="grid-content">
                        <div v-if="adIDsIndex[0]['list']">
                            <a v-for="(item, index) in adIDsIndex[0]['list']" :key="index" :href="item.adLink" target="_blank">
                                <img :src="item.adPicturePath" alt="" class="w100">
                            </a>
                        </div>
                        <div class="textCenter pointer" id="arrowAD" style="display: none;" @click="ADSlideToggle('530px')"><i class="el-icon-d-arrow-right arrow-ad"></i></div>
                        <div style="margin-bottom: 10px; height: 0px; overflow-y: hidden;" v-if="adIDsIndex[0]['list']" id="slideAD">
                            <a v-for="(item, index) in adIDsIndex[0]['list']" :key="index" :href="item.adLink" target="_blank">
                                <img src="../../assets/images/base_price_ad1.jpg" alt="" class="w100">
                            </a>
                        </div>

                        <div class="mw-modular-box p20 bgWhite" style="height: 530px; margin-top: -16px;">
                            <div class="part-tab">
                                <div class="part-tab-list">
                                    <el-tabs v-model="tagName" @tab-click="changeProductTag" class="textCenter">
                                        <el-tab-pane label="全国重点城市基准价" name="0" disabled class="first-tab">全国重点城市基准价</el-tab-pane>
                                        <el-tab-pane :label="item.basePriceName.substr(0, item.basePriceName.indexOf('全'))" :date="item.dataDate" :name="item.tag" v-for="(item, index) in productTag_list" :key="index">
                                            <!-- <p class="" style="height: 400px;"></p> -->
                                            <div class="map-btn-box" style="top: 0px;">
                                                <el-button class="bgRed fontWhite" size="small" @click="isShowTable = isShowTable ? false : true; btnText = btnText == '查看图表' ? '查看地图' : '查看图表'">{{ btnText }}</el-button>
                                            </div>
                                            <div class="map-box" v-show="!isShowTable">
                                                <div class="map-classify p10 textLeft">
                                                    <p v-for="(cItem, cIndex) in basePriceProduct_list" :key="cIndex" :class="{active: basePriceProduct_id == cItem.key}" class="pointer" @click="changeMapClassify(cItem.key, cItem.val)"><span class="circle"></span>{{ cItem.val }}</p>
                                                </div>
                                                <div class="grid-content bgGrey pos-relative"
                                                    v-loading="mapLoading"
                                                    element-loading-text="拼命加载中"
                                                    element-loading-spinner="el-icon-loading"
                                                    element-loading-background="rgba(255, 255, 255, 1)"
                                                >
                                                    <!-- 地图 start -->
                                                    <div :id="'mapChart_' + item.tag" style="height: 475px; width: 753.33px;"></div>
                                                    <!-- 地图 end -->
                                                </div>
                                            </div>
											<!-- title -->
											<div v-show="isShowTable" style="padding: 5px;padding-top: 7px; width: 100%; font-size: 16px; font-weight: bold">
												{{ basePriceName.indexOf('全') > 0 ? basePriceName : basePriceName + '全国基准价' }}
												<el-date-picker size="mini" style="width: 130px; margin-top: -5px; vertical-align: middle;" v-model="basePriceDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="日期" @change="changeBasePriceDate"></el-date-picker>
												
 												<el-select size="mini" style="margin-top: -5px; vertical-align: middle;margin-left: 5px;" v-model="customchoose" placeholder="选择品种" @change="changeTabClassify(customchoose)">
												        <el-option :label="cItem.val" :value="cItem.key" v-for="(cItem, cIndex) in basePriceProduct_list" :key="cIndex"></el-option>
												</el-select>
											</div>
                                            <div class="map-table-box center" v-show="isShowTable" style="width: 70%; margin-top: 10px;">
                                                <div class="mw-table-grid">
                                                    <div class="mw-table-row bgRed fontWhite">
                                                    	<div>时间</div>
                                                        <div>品种</div>
                                                        <div>地区</div>
                                                        <div>当期值</div>
                                                        <div>涨跌值</div>
                                                        <div>涨跌幅</div>
                                                        <div>历史最高</div>
                                                        <div>历史最低</div>
                                                    </div>
                                                    <div class="mw-table-row" v-for="(cItem, cIndex) in map_table_list" :key="cIndex">
                                                    	<div>{{ cItem.dataDate }}</div>
                                                        <div>{{ basePriceProduct_val }}</div>
                                                        <div>{{ cItem.areaName }}</div>
                                                        <div>{{ cItem.price }}元</div>
                                                        <div :class="{'fontGreen': cItem.chg < 0, 'fontRed': cItem.chg > 0, 'fontNormal': cItem.chg == 0}">{{ cItem.chg }}</div>
                                                        <div :class="{'fontGreen': cItem.chg < 0, 'fontRed': cItem.chg > 0, 'fontNormal': cItem.chg == 0}">{{ cItem.chgRadio ? cItem.chgRadio.toFixed(2) : 0.00 }}%</div>
                                                        <div>{{ cItem.highest }}元</div>
                                                        <div>{{ cItem.lowest }}元</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </el-tab-pane>
                                    </el-tabs>
                                </div>
                            </div>

                        </div>

                        <div v-if="adIDsIndex[3]['list']" style="margin: -10px 0">
                            <a v-for="(item, index) in adIDsIndex[3]['list']" :key="index" :href="item.adLink" target="_blank">
                                <img :src="item.adPicturePath" alt="" class="w100">
                            </a>
                        </div>

                        <div class="base-part-2 p20 bgWhite" style="min-height: 650px; position: relative;">
                            <div class="" ref="lineChart" style="height: 460px; margin-bottom: 20px;"></div>
                            <!-- <div class="font16" style="position: absolute; top: 200px; left: 46%; z-index: 2" v-if="isChartsEmpty">暂无数据~</div> -->

                            <el-form label-width="80px">
                                <el-row :gutter="20" v-for="(item, index) in childs_list" :key="index">
                                    <el-col :span="6">
                                        <el-form-item label="品种一级">
                                            <el-select v-model="item.tag" placeholder="选择品种" @change="changeTag(index)">
                                                <el-option :label="cItem.basePriceName.substr(0, cItem.basePriceName.indexOf('全'))" :value="cItem.tag" v-for="(cItem, cIndex) in  productTag_list" :key="cIndex"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6">
                                        <el-form-item label="品种二级">
                                            <el-select v-model="item.productId" placeholder="选择品种" @change="changeProduct(index)">
                                                <el-option :label="cItem.val" :value="cItem.key" v-for="(cItem, cIndex) in childs_list[index].productList" :key="cIndex"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                   
                                    <el-col :span="6">
                                        <el-form-item label="选择城市">
                                            <el-select v-model="item.areaName" placeholder="选择城市" @change="changeArea($event, index)">
                                                <el-option :label="cItem.val" :value="cItem.key" v-for="(cItem, cIndex) in item.areas_list" :key="cIndex"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="6" class="textRight little-btn">
                                        <el-button size="mini" @click="addProduct(index)">添加</el-button>
                                        <el-button size="mini" v-if="index > 0" @click="delProduct(index)">删除</el-button>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col :span="24" class="textCenter">
                                        <el-button type="danger" class="submit" @click="onSubmit">确认</el-button>
                                    </el-col>
                                </el-row>
                            </el-form>

                        </div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="grid-content">
                        <RecordAnalysis style="margin-bottom: 20px;"></RecordAnalysis>
                        <!-- <MapControl class="mw-modular-box"></MapControl> -->
                        <div v-if="adIDsIndex[1]['list']">
                            <a v-for="(item, index) in adIDsIndex[1]['list']" :key="index" :href="item.adLink" target="_blank">
                                <img :src="item.adPicturePath" alt="" class="w100">
                            </a>
                        </div>
                        <FastNewsControl style="margin-top: 20px;"></FastNewsControl>

                        <HotRecord style="margin-top: 20px;"></HotRecord>
                        
                    </div>
                </el-col>
            </el-row>
        </article>
        <ConcatsControl></ConcatsControl>
    </div>
</template>

<script>
import MapControl from '../../templates/mapControl'
import RecordAnalysis from '../../templates/recordAnalysis'
import HotRecord from '../../templates/hotRecord'
import ConcatsControl from '../../templates/concatsControl'
import FastNewsControl from '../../templates/fastNewsControl'
import $ from 'jquery'
import '../../../node_modules/echarts/map/js/china.js'
import { baseUrl, adIDs, getQueryString } from '../../assets/js/common'
import { MapOption, LineOption_2 } from '../../assets/js/options'

export default {
    name: 'BasePrice',
    components: { MapControl, RecordAnalysis, HotRecord, ConcatsControl, FastNewsControl },
    data () {
        return {
			customchoose:null,
            adIDsIndex: [{
                name: 'jzjA',
                id: adIDs['jzjA'],
                list: []
            },{
                name: 'jzjC',
                id: adIDs['jzjC'],
                list: []
            },{
                name: 'indexRight1',
                id: adIDs['indexRight1'],
                list: []
            },{
                name: 'jzj44',
                id: adIDs['jzj44'],
                list: []
            }],
            btnText: '查看地图',
            isShowTable: true,
            map_table_list: [],

            tagName: '',
            productTag_list: [],
            productChild_list: [],
            childs_list: [{tag: '', tagName: '', productName: '', productId: '', productList: [], areaId: '0', areas_list: [], areaName: '全国'}],
            chartsData: [],
            // isChartsEmpty: false,
            
            selected: 'china',
            dataDate: '',
            basePriceName: '',
            basePriceProduct_list: [],
            basePriceProduct_id: '',
            basePriceProduct_val: '',
            basePriceTab: '',
            mapLoading: false,
            basePriceDate: '',
            isChangeDate: false,
            changeDateProductId: ''
        }
    },
    mounted () {
        // 初始化内容

        this.findAllProductTag();
        this.getAdByAdp();
    },
    methods: {
        //页面操作
        // 获取广告信息
        getAdByAdp () {
            const self = this;
            // self.adIDsIndex = ;
            self.adIDsIndex.forEach((item, index) => {
                self.$get(`${baseUrl.cyw}/industriaAD/getAdByAdp?adpId=${item.id}`, {}).then(res => {
                    if (res.code == 0) {
                        self.adIDsIndex[index]['list'] = res.data;
                        if (index == 0) {
                            // let image = new Image();
                            // image.src = res.data[0]['adPicturePath'];
                            // image.onload = () => {
                            //     setTimeout(() => {
                            //         self.ADSlideToggle(image.height);
                            //     }, 700)
                            // }
                            setTimeout(() => {
                                // self.ADSlideToggle('530px');
                            }, 700)
                        }
                    }
                    
                })
            })
        },

        // 广告下滑特效
        ADSlideToggle (imgHeight) {
            $('#arrowAD').css('display', 'none');
            $('#slideAD').animate({'height': imgHeight}, 2000, () => {
                setTimeout (() => {
                    $('#slideAD').animate({'height': '0px'}, 2000, () => {
                        $('#arrowAD').css('display', 'block');
                    });
                }, 2000)
            })
        },

        // 获取所有大产品标识
        findAllProductTag () {
            const self = this;
            self.$get(`${baseUrl.online}/industriaBasePrise/findIndexTopList`, {}).then(res => {
                if (res.code == 0) {
                    self.productTag_list = res.data;
                    self.tagName = getQueryString('tag') ? getQueryString('tag') : res.data[0].tag;
                    self.childs_list[0].tag = self.tagName;
                    self.productTag_list.forEach((item, index) => {
                        if (item.tag == 'MJ') {
                            item.tag = `MJ_${item.type}`;
                        }
                        if (item.tag == self.tagName) {
                            self.dataDate = item.dataDate;
                            self.basePriceName = item.basePriceName;
                            self.childs_list[0].tagName = item.basePriceName;
                            self.findProducts(item.tag);
                        }
                    })
                } else {
                    // self.$message.error(res.message);
                }
            }).catch(err => {
                // self.$message.error('未获取到分类信息')
            })
        },
        changeProductTag (tab, event) { // 切换大分类，获取子产品
            this.dataDate = tab.$attrs.date;
            this.tagName = tab.name;
            this.basePriceName = tab.label;
            this.findProducts(tab.name);
            this.childs_list = [{tag: tab.name, tagName: '', productName: '', productId: '', productList: [], areaId: '0', areas_list: [], areaName: '全国'}];
            this.chartsData = [];
            this.map_table_list = [];

            this.basePriceDate = self.dataDate;
            this.isChangeDate = false;
            this.changeDateProductId = '';
        },

        // 根据大分类 获取子产品列表
        findProducts (tag, index) {
            const self = this;
            self.$get(`${baseUrl.online}/industriaBasePrise/findProducts?tag=${tag.indexOf('MJ') > -1 ? 'MJ' : tag}&type=${tag.indexOf('MJ') > -1 ? tag.substr(tag.indexOf('_') + 1, 1) : ''}`, {}).then(res => {
                if (res.code == 0) {
                    // self.productChild_list = res.data;
                    let _index = index ? index : 0;
                    let _key, _val;
                    res.data.forEach((item, index) => {
                        if (item.val == '高线') {
                            _key = item.key;
                            _val = item.val;
                        }
                        if (item.val == '热轧带钢') {
                            _key = item.key;
                            _val = item.val;
                        }
                        if (item.val == '镀锌圆管') {
                            _key = item.key;
                            _val = item.val;
                        }
                        if (item.val == '重型废钢') {
                            _key = item.key;
                            _val = item.val;
                        }
                    })
                    _key = _key ? _key : res.data[0].key;
                    _val = _val ? _val : res.data[0].val;
                    self.childs_list[_index].productList = res.data;
                    self.childs_list[_index].productName = _val;
                    self.childs_list[_index].productId = _key;
					debugger
                    self.changeProduct(_index);
					self.customchoose=_key;
                    if (index == undefined) {
                        self.basePriceProduct_id = _key;
                        self.basePriceProduct_val = _val;
                        self.findIndexList(_key);
                        self.findBasePriceRightList(_key);
                        self.basePriceProduct_list = res.data; // 地图左上角分类
                        // self.basePriceProduct_id = res.data[0].key;
                        // self.findIndexList(res.data[0].key);
                        self.onSubmit();
                    }
                    
                } else {
                    // self.$message.error(res.message);
                }
            }).catch(err => {
                // self.$message.error('未获取到产品信息');
            })
        },

        changeBasePriceDate (val) {
            console.log(val)
            this.isChangeDate = true;
            this.findBasePriceRightList(this.changeDateProductId);
            this.findIndexList(this.changeDateProductId);
        },

        // 获取地图列表数据
        findBasePriceRightList (productId) {
            const self = this;
            let tag = self.tagName;
            let type = '';
            if (self.tagName.indexOf('MJ') > -1) {
                tag = 'MJ';
                type = self.tagName.substr(3, 1);
            }
            let _url = '';
            if (self.isChangeDate) {
                _url = 'http://118.126.142.187:8088/online/industriaBasePrise/findBasePriceRightListByRq';
            } else {
                _url = 'http://114.113.152.67:9090/basePriceRedis/findBasePriceRightList';
            }
            self.$get(`${_url}?tag=${tag}&productId=${productId}&date=${self.isChangeDate ? self.basePriceDate : self.dataDate}&type=${type}`, {}).then(res => {
                if (res.code == 0) {
                    self.map_table_list = res.data;
                } else {
                    self.map_table_list = [];
                }
            })
        },

        // 获取地图数据
        findIndexList (productId) {
            const self = this;
            self.mapLoading = true;
            let tag = self.tagName;
            let type = '';
            if (self.tagName.indexOf('MJ') > -1) {
                tag = 'MJ';
                type = self.tagName.substr(3, 1);
            }
            // ${baseUrl.online}/industriaBasePrise/findBasePriceMap
            // http://192.168.0.16/basePriceRedis/findBasePriceMap
            // 
            let _url = '';
            if (self.isChangeDate) {
                _url = 'http://118.126.142.187:8088/online/industriaBasePrise/findBasePriceMapByRq';
            } else {
                _url = 'http://114.113.152.67:9090/basePriceRedis/findBasePriceMap';
            }
            self.$get(`${_url}?tag=${tag}&productId=${productId}&date=${self.isChangeDate ? self.basePriceDate : self.dataDate}&type=${type}`, {}).then(res => {
                if (res.code == 0) {
                    res.data = res.data == null ? [] : res.data;
                    // let map_table_list_new = [];
                    // res.data.forEach((item, index) => {
                    //     if (item.provinceTag != 'Y') {
                    //         map_table_list_new.push(item);
                    //     }
                    // })
                    // self.map_table_list = $.extend(true, [], map_table_list_new);
                    let arr = [];
                    let mapChart = self.$echarts.init(document.getElementById('mapChart_' + self.tagName)); //这里是为了获得容器所在位置
                    window.onresize = mapChart.resize;
                    let option = new MapOption();
                    option.series[0].name = `${self.basePriceName}`;
                    
                    self.isChangeDate ? null : (self.basePriceDate = res.data[0].dataDate);
                    self.changeDateProductId = productId;
                    // option.title.text = `${self.basePriceName.indexOf('全') > 0 ? self.basePriceName : self.basePriceName + '全国基准价'}`+'('+ res.data[0].dataDate+')';

                    res.data.forEach((cItem, cIndex) => {
                        if (cItem.areaName.indexOf('省') > 0) {
                            const i = cItem.areaName.indexOf('省');
                            cItem.areaName = cItem.areaName.substr(0, i);
                        } else if (cItem.areaName.indexOf('内蒙古') > -1) {
                            cItem.areaName = cItem.areaName.substr(0, 3);
                        } else if (cItem.areaName.indexOf('天津') > -1 || cItem.areaName.indexOf('上海') > -1 || cItem.areaName.indexOf('重庆') > -1 || cItem.areaName.indexOf('北京') > -1 || cItem.areaName.indexOf('广西') > -1 || cItem.areaName.indexOf('新疆') > -1 || cItem.areaName.indexOf('宁夏') > -1 || cItem.areaName.indexOf('西藏') > -1) {
                            cItem.areaName = cItem.areaName.substr(0, 2);
                        }

                        // var hasArea = false;
                        // $.each(arr, (arrIndex, arrItem) => {
                        //     if (arrItem.name == cItem.areaName) {
                        //         hasArea = true;
                        //     }
                        // })
                        // if (!hasArea) {
                        //      arr.push({
                        //         name: cItem.areaName, 
                        //         value: cItem.chg, 
                        //         price: cItem.price, 
                        //         chgRadio: cItem.chgRadio ? cItem.chgRadio.toFixed(2) : 0.00, 
                        //         originalName: cItem.originalName, 
                        //         date: cItem.dataDate
                        //     })
                        // }

                        if (cItem.provinceTag == 'Y') {
                            var hasArea = false;
                            $.each(arr, (arrIndex, arrItem) => {
                                if (arrItem.name == cItem.areaName) {
                                    hasArea = true;
                                }
                            })
                            if (!hasArea) {
                                arr.push({
                                    name: cItem.areaName, 
                                    value: cItem.chg, 
                                    price: cItem.price, 
                                    chgRadio: cItem.chgRadio ? cItem.chgRadio.toFixed(2) : 0.00, 
                                    originalName: cItem.originalName, 
                                    date: cItem.dataDate
                                })
                            }
                            // arr.push({
                            //     name: cItem.areaName, 
                            //     value: cItem.chg, 
                            //     price: cItem.price, 
                            //     chgRadio: cItem.chgRadio ? cItem.chgRadio.toFixed(2) : 0.00, 
                            //     originalName: cItem.originalName, 
                            //     date: cItem.dataDate
                            // })
                        }
                    })
                    option.series[0].data = arr;
                    option.series[0].zoom = 1.2;
                    mapChart.setOption(option, {notMerge: true});
                    self.mapLoading = false;
                    // 参数为要显示地图区域的名字
                    let loadMap = (param) => {
                        if (param != 'china') {
                            let option_1 = new MapOption();
                            let arr_1 = [];
                            option_1.series[0].name = `${self.basePriceName}`;
                            option_1.title.text = `${self.basePriceName.indexOf('全') > 0 ? self.basePriceName : self.basePriceName + '全国基准价'}`;
                            option_1.series[0].zoom = 1.1;
                            option_1.series[0].map = param;
                            // 整合两个唐山市港口数据
                            const tss = res.data.filter((datas) => {
                                return datas.areaName == '唐山市';
                            })
                            let tsObj = tss.length > 0 ? tss[0] : {};
                            tsObj.dataVo = tss.length > 1 ? tss[1] : null;
                            tsObj.towStr = tss.length > 1 ? 'Y' : null;
                            // 整合两个唐山市港口数据
                            res.data.forEach((cItem, cIndex) => {
                                if (cItem.areaName == '唐山市') {
                                    arr_1.push({
                                        name: cItem.areaName, 
                                        value: cItem.chg, 
                                        price: cItem.price, 
                                        chgRadio: cItem.chgRadio ? cItem.chgRadio.toFixed(2) : 0.00, //cItem.chgRadio.toFixed(2), 
                                        originalName: cItem.originalName, 
                                        date: cItem.dataDate,
                                        towStr: tsObj.towStr,
                                        voName: tsObj.towStr == 'Y' ? tsObj.dataVo.areaName : '',
                                        voValue: tsObj.towStr == 'Y' ? tsObj.dataVo.chg : '',
                                        voPrice: tsObj.towStr == 'Y' ? tsObj.dataVo.price : '',
                                        voChgRadio: tsObj.towStr == 'Y' ? tsObj.dataVo.chgRadio.toFixed(2) : '',
                                        voOriginalName: tsObj.towStr == 'Y' ? tsObj.dataVo.originalName : ''
                                    })
                                } else {
                                    arr_1.push({
                                        name: cItem.areaName, 
                                        value: cItem.chg, 
                                        price: cItem.price, 
                                        chgRadio: cItem.chgRadio ? cItem.chgRadio.toFixed(2) : 0.00, //cItem.chgRadio.toFixed(2), 
                                        originalName: cItem.originalName, 
                                        date: cItem.dataDate
                                    })
                                }
                            })
                            option_1.series[0].data = arr_1;
                            mapChart.setOption(option_1);
                        } else {
                            option.series[0].data = arr;
                            mapChart.setOption(option);
                        }
                    }
                    
                    let provinces = ['shanghai', 'hebei','shanxi','neimenggu','liaoning','jilin','heilongjiang','jiangsu','zhejiang','anhui','fujian','jiangxi','shandong','henan','hubei','hunan','guangdong','guangxi','hainan','sichuan','guizhou','yunnan','xizang','shanxi1','gansu','qinghai','ningxia','xinjiang', 'beijing', 'tianjin', 'chongqing', 'xianggang', 'aomen', 'taiwan']
                    let provincesText = ['上海', '河北', '山西', '内蒙古', '辽宁', '吉林','黑龙江',  '江苏', '浙江', '安徽', '福建', '江西', '山东','河南', '湖北', '湖南', '广东', '广西', '海南', '四川', '贵州', '云南', '西藏', '陕西', '甘肃', '青海', '宁夏', '新疆', '北京', '天津', '重庆', '香港', '澳门', '台湾']
                    
                    // 判断当前要加载的地图是不是省？
                    let isProvince = (name) => {
                        return provincesText.some((province) => {
                            return province === name
                        })
                    }

                    // 定义方法加载某个省的地图文件
                    let loadScriptMap = (name, callback) => {
                        // 获取这个省的拼音名字 name = '四川' => pinyinName = 'sichuan'
                        let pinyinName = provinces[provincesText.indexOf(name)]
                        // 引入这个对应的地图JS，如果是在项目中要打包，请将这些文件提取出来，放在静态资源中
                        // build的时候这些文件不会被打包，无可加载资源地图是不会显示的！！！！
                        let currentMap = require(`echarts/map/js/province/${pinyinName}`)
                        callback(name)
                    }
                    mapChart.on('click', function (param) {
                        if (isProvince(param.name)) {
                            self.selected = param.name
                            // 从外部加载这个省的地图文件
                            loadScriptMap(param.name, loadMap)
                        } else {
                            // 否则切换中国地图
                            self.selected = 'china'
                            loadMap(self.selected)
                        }
                    })
                } else {
                    self.mapLoading = false;
                }
            }).catch(err => {self.mapLoading = false;})
        },
        changeMapClassify (tag, val) {
            this.basePriceProduct_id = tag;
            this.basePriceProduct_val = val;
            this.findIndexList(tag);
            this.findBasePriceRightList(tag);
        },
		changeTabClassify(tag){
			var self=this;
			self.basePriceProduct_list.forEach((cItem, cIndex) => {
                if (cItem.key == tag) {
					self.basePriceProduct_id = tag;
					self.basePriceProduct_val = cItem.val;
					self.findIndexList(tag);
					self.findBasePriceRightList(tag);
                }
            })
		},
        // 选择一级产品
        changeTag (index) {
            const self = this;
            self.forEachTag(index, self.childs_list[index]['tag']);
            self.findProducts(self.childs_list[index]['tag'], index)
        },

        // 选择产品 获取地区
        changeProduct (index) {
            const self = this;
            self.forEachProduct(index, self.childs_list[index]['productId']);
            self.$get(`${baseUrl.online}/industriaBasePrise/findAreas?productId=${self.childs_list[index]['productId']}&tag=${self.childs_list[index]['tag'].indexOf('MJ') > -1 ? 'MJ' : self.childs_list[index]['tag']}`, {}).then(res => {
                if (res.code == 0) {
                    self.childs_list[index]['areas_list'] = res.data;
                    if (self.childs_list.length == 1) {
                        self.childs_list[index]['areaName'] ? self.childs_list[index]['areaName'] = '全国' : '';
                        self.childs_list[index]['areaId'] ? self.childs_list[index]['areaId'] = '0' : '';
                    } else {
                        self.childs_list[index]['areaName'] ? self.childs_list[index]['areaName'] = '' : '';
                        self.childs_list[index]['areaId'] ? self.childs_list[index]['areaId'] = '' : '';
                    }
                } else {
                    // self.$message.error(res.message);
                }
            }).catch(err => {
                // self.$message.error('未获取到地区信息');
            })
        },
        // 选择地区
        changeArea (e, index) {
            const self = this;
            const list = self.childs_list[index]['areas_list'];
            list.forEach((cItem, cIndex) => {
                if (cItem.key == e) {
                    self.childs_list[index]['areaName'] = cItem.val;
                    self.childs_list[index]['areaId'] = cItem.key;
                }
            })
        },

        // 添加一项
        addProduct (index) {
            if (this.childs_list.length  == 5) {
                this.$message({
                    message: '最多选择5种',
                    type: 'warning'
                })
            } else {
                const obj = {productName: '', productId: '', areaId: '', areas_list: []};
                // this.childs_list.splice(index + 1, 0, obj);
                this.childs_list.push(obj);
            }
        },

        // 删除一项
        delProduct (index) {
            this.childs_list.splice(index, 1);
        },

        // 查找一级产品名称
        forEachTag (index, id) {
            const self = this;
            self.productTag_list.forEach((item, i) => {
                if (id == item.tag) {
                    self.childs_list[index].tagName = item.basePriceName;
                }
            })
        },

        // 查找产品名称
        forEachProduct (index, id) {
            const self = this;
            self.childs_list[index]['productList'].forEach((item, i) => {
                if (id == item.key) {
                    self.childs_list[index].productName = item.val;
                }
            })
        },

        // 提交数据
        onSubmit () {
            const self = this;
            // self.isChartsEmpty = true;
            if(self.chartsData.length > self.childs_list.length) {
                self.chartsData.splice(self.childs_list.length, self.chartsData.length);
            }
            self.childs_list.forEach((item, index) => {
                if (!item.tag) {
                    self.$message.error('请选择品种');
                    return;
                } else if (!item.areaId) {
                    self.$message.error('请选择地区');
                    return;
                }
                let type = '';
                let tag = item.tag;
                if (tag.indexOf('MJ') > -1) {
                    tag = 'MJ';
                    type = tag.substr(3, 1);
                }
                self.$get(`${baseUrl.online}/industriaBasePrise/findData?tag=${tag}&productId=${item.productId}&areaId=${item.areaId}&type=${type}`, {}).then(res => {
                    if (res.code == 0) {
                        // 得到图表数据
                        const obj = {name: item.productName, area: item.areaName ? item.areaName : '', data: res.data};
                        self.chartsData[index] = obj;
                        if (index == self.childs_list.length - 1) {
                            self.lineChartInit();
                        }
                    } else {
                        // self.$message.error(res.message);
                    }
                }).catch(err => {
                    // self.$message.error('未获取到图表信息');
                })
                
            })
        },

        // // 全部加载完成， 进行线图绘制
        lineChartInit () {
            const self = this;
            let lineChart = self.$echarts.init(self.$refs.lineChart);
            let option = new LineOption_2();
            let seriesObj = {};
            let newItemObj = {};
            self.chartsData.forEach((item, index) => {
                seriesObj = {
                    type: 'line',
                    name: item.name + item.area,
                    smooth: true,
                    smoothMonotone: 'none',
                    connectNulls: true,
                    data: []
                }
                newItemObj = self.lastYearData(item.data);
                option.xAxis.data = newItemObj.dates;
                seriesObj.data = newItemObj.prices;
                option.series.push(seriesObj);
            })
            option.dataZoom = [
                {
                    type: 'inside',
                    start: 50,
                    end: 100
                },
                {
                    show: true,
                    type: 'slider',
                    y: '90%',
                    start: 50,
                    end: 100
                }
            ],
            option.grid.right = 25;
            option.grid.top = 60;
            option.grid.bottom = 60;
            lineChart.setOption(option, { notMerge: true });
        },

        // 获取当前年份的前一年 并返回数组中前一年之后的数据
        lastYearData (arr) {
            const theLast = arr[arr.length - 1]['rq'];
            // console.log(theLast)
            let date = new Date(theLast).getTime();
            let lastDate = 0;
            let newDates = [];
            let newPrices = [];
            let arrDate = [];
            let arrPrice = [];
            arr.forEach((item, index) => {
                arrDate.push(item.rq);
                arrPrice.push(item.price);
            })
            for (var i = 0; i < 365; i++) {
                lastDate = date - (1000 * 60 * 60 * 24 * i);
                lastDate = new Date(lastDate)
                newDates.push(`${lastDate.getFullYear()}-${lastDate.getMonth() + 1 >= 10 ? (lastDate.getMonth() + 1) : '0' + (lastDate.getMonth() + 1)}-${lastDate.getDate() >= 10 ? lastDate.getDate() : '0' + lastDate.getDate()}`);
                let dateIndex = arrDate.indexOf(newDates[i]);
                dateIndex > -1 ? newPrices.push(arrPrice[dateIndex]) : newPrices.push(null)
            }
            return {
                dates: newDates.reverse(),
                prices: newPrices.reverse()
            }

        },


    },
}
</script>

<style scoped>
    @import url('basePrice.css');
</style>